import React, { useState } from "react";

const CustomButton = ({
  onClick,
  color = "green",
  className = "",
  disabled = false,
  children = "Play Now",
  shadowColor = null,
}) => {
  const [pressed, setPressed] = useState(false);

  const baseClasses = `
    relative
    font-black
    uppercase
    tracking-wide
    transition-all
    duration-100
    cursor-pointer
    select-none
    text-lg md:text-base px-5 py-2
  `;

  const colorConfigs = {
    green: {
      bg: "bg-[#53D337]",
      shadow: "#3a9325",
      text: "text-black"
    },
    pink: {
      bg: "bg-pinkShade",
      shadow: "#B330A6",
      text: "text-black"
    },
    practice: {
      bg: "bg-[#F5F5F5]/20",
      shadow: "#F5F5F515",
      text: "text-white"
    }
  };

  const config = colorConfigs[color] || colorConfigs.green;
  const activeShadow = shadowColor || config.shadow;

  const threeDClasses = `
    ${config.bg}
    ${config.text}
    hover:brightness-105
  `;

  const disabledClasses = disabled
    ? "opacity-50 cursor-not-allowed"
    : "";

  // Dynamic press effect CSS
  const pressEffect = pressed
    ? `translate-y-[4px]`
    : `translate-y-0`;

  const shadowStyle = pressed
    ? `0 0px 0 0 ${activeShadow}`
    : `0 4px 0 0 ${activeShadow}`;

  return (
    <button
      onMouseDown={() => !disabled && setPressed(true)}
      onMouseUp={() => setPressed(false)}
      onMouseLeave={() => setPressed(false)}
      onTouchStart={() => !disabled && setPressed(true)}
      onTouchEnd={() => setPressed(false)}
      onClick={onClick}
      disabled={disabled}
      style={{
        borderRadius: "var(--button-radius)",
        boxShadow: shadowStyle
      }}
      className={`
        ${baseClasses}
        ${threeDClasses}
        ${pressEffect}
        ${disabledClasses}
        ${className}
      `}
    >
      {children}
    </button>
  );
};

export default CustomButton;
